module.exports = __webpack_public_path__ + "static/img/guide1.7c54b96a.png";